import { useCallback, useState } from 'react';

interface IProps {
  handler?: () => void;
}

export const useModal = ({ handler }: IProps) => {
  const [isActive, setActive] = useState(false);

  const toggleHandler = useCallback(() => {
    setActive((prev) => !prev);
    handler && handler();
  }, [handler]);

  return { isActive, setActive, toggleHandler };
};
